/* ============================================================
   DEAD FLIGHT ARROWS — dfa-collection.js
   Soumission auto du formulaire de filtres + tri.
   ============================================================ */
(function () {
  'use strict';
  class DfaFiltres extends HTMLElement {
    connectedCallback() {
      this.formulaire = this.querySelector('form');
      this._surChangement = this.surChangement.bind(this);
      if (this.formulaire) this.formulaire.addEventListener('change', this._surChangement);
    }
    disconnectedCallback() {
      if (this.formulaire) this.formulaire.removeEventListener('change', this._surChangement);
    }
    surChangement(e) {
      /* Les champs de prix se soumettent au bouton (éviter une requête par frappe) */
      if (e.target.type === 'number') return;
      this.formulaire.submit();
    }
  }
  if (!customElements.get('dfa-filtres')) customElements.define('dfa-filtres', DfaFiltres);
})();
